import "./taktour.scss";

import { FaCity, FaRegMoneyBillAlt } from "react-icons/fa";
import { IoIosChatbubbles } from "react-icons/io";
import { FaShoppingCart, FaCampground, FaCcVisa, FaChevronDown } from "react-icons/fa";
import axios from "axios";
import { useEffect, useState } from "react";
import Similar from "./Similar";
import DailyScheduleTable from "./DailyScheduleTable.tsx";
import TimeLine from "./TimeLine";
import { useParams, useHistory } from "react-router-dom";
import Loader from "utilities/Loader";
export default function TakTour() {
  const params = useParams();
  const history = useHistory();

  const [daysLength, setDaysLength] = useState(0);
  const [tourInformation, settourInformation] = useState();
  const [tourCategory, setTourCategory] = useState([]);
  const [tourAttractions, setTourAttractions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [similarTours, setSimilarTours] = useState({
    similarPrice: [],
    similarDate: [],
    similarInterval: [],
    attraction: [],
  });
  const [otherFields, setOtherFields] = useState({ startPoint: "", forecast: "" });
  const tourId = parseInt(params.tourId);
  const date = (TimeStamp) => {
    let options = { year: "numeric", month: "numeric", day: "numeric" };
    let date = new Date(parseInt(TimeStamp) * 1000).toLocaleDateString("fa-IR", options);
    date.replace(/([۰-۹])/g, (token) => String.fromCharCode(token.charCodeAt(0) - 1728));
    return date;
  };

  useEffect(() => {
    setIsLoading(true);
    let FD = new FormData();
    FD.append("tour_id", tourId);

    axios.post("http://mvc.dade24.ir/api/fulltour", FD).then((res) => {
      if (res.data.data.length != 0) {
        settourInformation(res.data.data[0]);
      } else {
        history.push("/");
        return "";
      }
      let dailySchedule = [...res.data.data[0].tour_daily_schedule];
      let finalLength = 0;

      for (let index = 0; index < dailySchedule.length; index++) {
        if (finalLength < parseInt(dailySchedule[index].daynum)) finalLength = parseInt(dailySchedule[index].daynum);
      }
      setDaysLength(finalLength);
    });
    let FD1 = new FormData();
    FD1.append("conditions", "tour_id/=/" + tourId);
    FD1.append("tbl_name", "tour_tags");
    axios.post("http://mvc.dade24.ir/api/Find_tour_tags_links", FD1).then((res) => {
      setTourCategory(res.data);
    });
    let FD3 = new FormData();
    FD3.append("conditions", "tour_id/=/" + tourId);
    FD3.append("tbl_name", "attractions");
    axios.post("http://mvc.dade24.ir/api/Find_tour_Attraction_links", FD3).then((res) => {
      setTourAttractions(res.data);
    });
  }, []);
  // fulltour => tour_id
  useEffect(() => {
    if (tourInformation != null) {
      let FD4 = new FormData();
      let before = tourInformation.mainprice - 500000;
      let after = parseInt(tourInformation.mainprice) + 500000;
      FD4.append("conditions", "mainprice/between/" + before + "," + after);

      let FD5 = new FormData();
      let before1 = tourInformation.stm - 172800;
      let after1 = parseInt(tourInformation.stm) + 172800;
      FD5.append("conditions", "stm/between/" + before1 + "," + after1);

      let FD6 = new FormData();
      let current = tourInformation.ftm - tourInformation.stm;
      let before2 = current - 86400;
      let after2 = parseInt(current) + 86400;
      FD6.append("conditions", "(ftm-stm)/between/" + before2 + "," + after2);

      let FD7 = new FormData();
      FD7.append("tbl_name", "attractions");
      FD7.append("fields", "attractions.title,tour_id");

      let FD8 = new FormData();
      FD8.append("fields", "val");
      FD8.append("conditions", "code/=/3@@tour_id/=/" + tourId);

      let FD9 = new FormData();
      FD9.append("fields", "val");
      FD9.append("conditions", "code/=/9@@tour_id/=/" + tourId);
      function getTourId(tours) {
        let toursId = "";
        for (let index = 0; index < tours.length; index++) {
          for (let index2 = 0; index2 < tours[index].length; index2++) {
            if (toursId == "") {
              toursId = tours[index][index2].id;
            } else {
              toursId = toursId + "," + tours[index][index2].id;
            }
          }
        }

        return toursId;
      }

      if (Object.keys(tourInformation).length) {
        axios.post("http://mvc.dade24.ir/api/Find_tours", FD4).then(({ data }) => {
          axios.post("http://mvc.dade24.ir/api/Find_tours", FD5).then(({ data: data1 }) => {
            axios.post("http://mvc.dade24.ir/api/Find_tours", FD6).then(({ data: data2 }) => {
              FD7.append("conditions", "tour_id/in/" + getTourId([data, data1, data2]));
              axios.post("http://mvc.dade24.ir/api/Find_tour_Attraction_links", FD7).then(({ data: data3 }) => {
                console.log("data1", data3);
                setSimilarTours({ similarDate: data1, similarPrice: data, similarInterval: data2, attractions: data3 });
                setIsLoading(false);
              });
            });
          });
        });
        axios.post("http://mvc.dade24.ir/api/Find_tour_other_field_values", FD8).then(({ data: data3 }) => {
          axios.post("http://mvc.dade24.ir/api/Find_tour_other_field_values", FD9).then(({ data: data4 }) => {
            return setOtherFields({ startPoint: data3, forecast: data4 });
          });
        });
      }
    }
  }, [tourInformation]);
  const tourTransport = (transport_type) => {
    console.log(transport_type, "transport_type");
    const typeArray = transport_type[0].val.split("+");
    var res = "";
    console.log(typeArray);
    for (let index = 0; index < typeArray.length; index++) {
      if (+typeArray[index] == 1) {
        res += " هوایی";
      } else if (+typeArray[index] == 2) {
        res += " زمینی ";
      } else if (+typeArray[index] == 3) {
        res += " ریلی ";
      }
    }

    return res;
  };
  if (tourInformation) {
    return (
      <div className="taktour ">
        {isLoading && <Loader></Loader>}
        <div>
          <div>
            <div id="carouselExampleIndicators" className="carousel slide mycarousel " data-bs-ride="carousel">
              <div className="carousel-indicators">
                <button type="button" data-bs-target={`#carouselExampleIndicators-${0}`} data-bs-slide-to={0} className="active" />
                {tourInformation.attraction?.map((value, index) => {
                  return <button type="button" data-bs-target={`#carouselExampleIndicators-${index + 1}`} data-bs-slide-to={index + 1} />;
                })}
              </div>
              <div className="carousel-inner carousell  ">
                <div className={"carousel-item active carousell"} id="carouselExampleIndicators-0">
                  <img src={"http://mvc.dade24.ir/" + tourInformation.cover_pic} className="d-block w-100" alt="..." />
                </div>
                {tourInformation.attraction?.map((value, index) => {
                  return (
                    <div className={`carousel-item carousell`} id={`carouselExampleIndicators-${index + 1}`}>
                      <img src={"http://mvc.dade24.ir/" + value.mainpic} className="d-block w-100" alt="..." />
                    </div>
                  );
                })}
              </div>
              <button className="carousel-control-prev " type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true" />
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true" />
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          {/* fields and time line */}
          {/* fields */}
          <div className="row mt-5 fs-5 justify-content-center mx-0">
            <div className=" col-lg-3 col-sm-7 ">
              <div className="row border text-light TourDetails">
                <FaCampground className=" material-icons col-2 fs-5 " style={{ paddingLeft: "29px" }} />
                <p className="col-10 my-2" style={{ alignContent: "baseline" }}>
                  نام تور :{tourInformation.title}
                </p>
              </div>
              <div className="row border text-light TourDetails">
                <FaCampground className=" material-icons col-2 fs-5 " style={{ paddingLeft: "29px" }} />
                <p className="col-10 my-2" style={{ alignContent: "baseline" }}>
                  شهر :{tourInformation.city?.map((value) => value.title + " ")}
                </p>
              </div>
              <div className="row border text-light TourDetails mt-2">
                <span className=" material-icons mt-2 col-2">menu</span>
                <p className="col-10 my-2" style={{ alignContent: "baseline" }}>
                  دسته بندی :
                  {tourCategory.map((value, index) => {
                    return <span>{(index ? " , " : "") + value.title}</span>;
                  })}
                </p>
              </div>
              <div className="row border text-light TourDetails mt-2">
                <span className=" material-icons mt-2 col-2">image</span>
                <p className="col-10 my-2" style={{ alignContent: "baseline" }}>
                  جاذبه ها :
                  {tourAttractions?.map((value, index) => {
                    return <span>{(index ? " , " : "") + value.title}</span>;
                  })}
                </p>
              </div>

              <div className="row border text-light TourDetails mt-2">
                <span className=" material-icons mt-2 col-2">calendar_today</span>
                <p className="col-10 my-2" style={{ alignContent: "baseline" }}>
                  {" "}
                  زمان شروع تور :{date(tourInformation.stm)}
                </p>
              </div>
              <div className="row border text-light TourDetails mt-2">
                <span className=" material-icons mt-2 col-2">calendar_today</span>
                <p className="col-10 my-2" style={{ alignContent: "baseline" }}>
                  {" "}
                  زمان پایان تور :{date(tourInformation.ftm)}
                </p>
              </div>
              <div className="row border text-light TourDetails mt-2">
                <span className=" material-icons mt-2 col-2">home</span>
                <p className="col-10 my-2" style={{ alignContent: "baseline" }}>
                  بیمه :{parseInt(tourInformation.insurence) ? "دارد" : "ندارد"}
                </p>
              </div>
              <div className="row border text-light TourDetails mt-2">
                <FaCcVisa className=" material-icons col-2 fs-5 " style={{ paddingLeft: "29px" }} />
                <p className="col-10 my-2" style={{ alignContent: "baseline" }}>
                  {" "}
                  ویزا :{parseInt(tourInformation.visa) ? "دارد" : "ندارد"}
                </p>
              </div>
              <div className="row border text-light TourDetails mt-2">
                <span className=" material-icons mt-2 col-2">equalizer</span>
                <p className="col-10 my-2" style={{ alignContent: "baseline" }}>
                  درجه سختی :{tourInformation.hardshiplevel}
                </p>
              </div>
              {tourInformation.essentials_accessories != 0 ? (
                <div className="row border text-light TourDetails mt-2">
                  <span className=" material-icons mt-2 col-2">restaurant</span>
                  <p className="col-10 my-2" style={{ alignContent: "baseline" }}>
                    لوازم ضروری :{tourInformation.essentials_accessories}
                  </p>
                </div>
              ) : null}

              <div className="row border text-light TourDetails mt-2">
                <span className=" material-icons mt-2 col-2">place</span>
                <p className="col-10 my-2" style={{ alignContent: "baseline" }}>
                  محل حرکت :{otherFields.startPoint[0]?.val}
                </p>
              </div>

              <div className="row border text-light TourDetails mt-2">
                <span className=" material-icons mt-2 col-2">place</span>
                <p className="col-10 my-2" style={{ alignContent: "baseline" }}>
                  تور لیدر :
                  {tourInformation.leader_user?.map((value) => {
                    return value.fname + " " + value.lname + "  ";
                  })}
                </p>
              </div>
              <div className="row border text-light TourDetails mt-2">
                <span className=" material-icons mt-2 col-2">lock</span>
                <p className="col-10 my-2" style={{ alignContent: "baseline" }}>
                  نوع سفر :{tourTransport(tourInformation.transport_type)}
                </p>
              </div>

              <div className="row border text-light TourDetails mt-2">
                <span className=" material-icons mt-2 col-2">thermostat</span>
                <p className="col-10 my-2" style={{ alignContent: "baseline" }}>
                  {console.log("tourInformation", tourInformation)}
                  ظرفیت تور :{tourInformation.complate_reserved + tourInformation.frozen_reserved - tourInformation.public_capacity}
                </p>
              </div>
              <div className="row  light-purple-btn align-items-center">
                <span className=" col-2" style={{ fontSize: "20px" }}>
                  <FaRegMoneyBillAlt></FaRegMoneyBillAlt>
                </span>{" "}
                <p className="col-10 my-2" style={{ alignContent: "baseline" }}>
                  قیمت:
                  {tourInformation.mainprice}
                </p>
              </div>
              <div className="row  light-purple-btn align-items-center">
                <span className=" col-2" style={{ fontSize: "20px" }}>
                  <FaShoppingCart></FaShoppingCart>
                </span>{" "}
                <p className="col-10 my-2" style={{ alignContent: "baseline" }}>
                  خرید - رزرو آنلاین
                </p>
              </div>
            </div>
            <TimeLine daysLength={daysLength} dailySchedule={tourInformation.tour_daily_schedule} weather={otherFields.forecast[0]?.val}></TimeLine>
          </div>
          <DailyScheduleTable daysLength={daysLength} dailySchedule={tourInformation.tour_daily_schedule}></DailyScheduleTable>

          <Similar similarTours={similarTours} date={date}></Similar>
        </div>
      </div>
    );
  } else {
    return "";
  }
}
